/**
 * Utility functions module
 */

export function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    };
}

export function formatTimestamp(timestamp) {
    return new Date(timestamp * 1000).toLocaleString();
}

export function copyToClipboard(text) {
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(text);
    } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        return Promise.resolve();
    }
}

export function generateState() {
    const array = new Uint32Array(4);
    crypto.getRandomValues(array);
    return Array.from(array, num => num.toString(16)).join('');
}

/**
 * 저장 상태 표시 (`.cal-save-state` 류 요소 공용).
 * state: 'saving' | 'saved' | 'error' | 'idle'. 문구는 el.dataset.lSaving/lSaved/lError
 * (opts.saving/saved/error 로 덮어쓸 수 있다). 'saved' 는 1500ms 뒤 자동으로 'idle'.
 */
export function setSaveState(el, state, opts) {
    if (!el) return;
    const o = opts || {};
    const d = el.dataset || {};
    clearTimeout(el._t);
    el.classList.remove('err');
    if (state === 'idle' || !state) {
        el.classList.remove('show');
        return;
    }
    let text = '';
    if (state === 'saving') text = o.saving || d.lSaving || '저장 중…';
    else if (state === 'saved') text = o.saved || d.lSaved || '저장됨';
    else if (state === 'error') text = o.error || d.lError || '저장 실패';
    el.textContent = text;
    el.classList.add('show');
    if (state === 'error') el.classList.add('err');
    if (state === 'saved') el._t = setTimeout(() => setSaveState(el, 'idle'), o.delay == null ? 1500 : o.delay);
}
